/* [EZ] Raw-HTML behaviors for the scraped ez-pdp-body-* snippets.
   The source site's inline click JS was never scraped, so its interactive image
   switchers were dead. This revives them dynamically (no hardcoded ids) and applies a
   small mobile layout normalization. Loaded once from ez-pdp-raw.liquid.

   Switcher conventions handled:
   1) Checkbox: <input type=checkbox onclick="change_imgN(this.checked ? 0 : 1)"> drives
      `.switch_wrapper_N` (N may be empty → `.switch_wrapper`). State images are `img.switch`
      (index 0 = checked/enhanced, 1 = unchecked/plain).
   2) Buttons: a group of <span class="button_M button_switch"> drives the nearest
      `.switch_wrapper_*` (closest common ancestor). Button M → image index M-1.
   Visibility is applied via the `.active` class (see ez-switcher.css). */
(function () {
  'use strict';

  // Switchable images in a wrapper: checkbox wrappers use img.switch; button wrappers
  // hold plain <img>. Fall back to all images when there are no explicit .switch images.
  function imagesOf(wrapper) {
    var sw = wrapper.querySelectorAll('img.switch');
    return sw.length ? sw : wrapper.querySelectorAll('img');
  }

  function setActive(wrapper, index) {
    var imgs = imagesOf(wrapper);
    if (!imgs.length) return;
    var i = Math.max(0, Math.min(index, imgs.length - 1));
    Array.prototype.forEach.call(imgs, function (im, k) { im.classList.toggle('active', k === i); });
  }

  function byClass(cls) { return document.querySelectorAll('.' + cls); }

  /* ---- Convention 1: checkbox change_img[N] ---- */
  function initCheckboxes(root) {
    root.querySelectorAll('.ez-rawhtml input[type="checkbox"][onclick*="change_img"]').forEach(function (cb) {
      var m = (cb.getAttribute('onclick') || '').match(/change_img(\d*)/);
      if (!m) return;
      var suffix = m[1];                                   // '' | '3' | '4' ...
      var cls = 'switch_wrapper' + (suffix ? '_' + suffix : '');
      var apply = function (index) { byClass(cls).forEach(function (w) { setActive(w, index); }); };

      // Define the global that the inline onclick already calls.
      window['change_img' + suffix] = apply;

      if (!cb.__ezSwitchBound) {
        cb.addEventListener('change', function () { apply(cb.checked ? 0 : 1); });
        cb.__ezSwitchBound = true;
      }
      apply(cb.checked ? 0 : 1);                            // initial paint
    });
  }

  /* ---- Convention 2: .button_switch groups ---- */
  function nearestWrapper(el) {
    var node = el;
    while (node && node.nodeType === 1) {
      var w = node.querySelector('[class*="switch_wrapper"]');
      if (w) return w;
      node = node.parentElement;
    }
    return null;
  }

  function buttonIndex(btn, group) {
    var m = btn.className.match(/button_(\d+)/);
    if (m) return parseInt(m[1], 10) - 1;                  // button_3 -> index 2
    return Array.prototype.indexOf.call(group, btn);       // fallback: DOM position
  }

  function initButtons(root) {
    var seen = [];
    root.querySelectorAll('.ez-rawhtml .button_switch').forEach(function (btn) {
      var container = btn.parentElement;
      if (!container || seen.indexOf(container) !== -1) return;
      seen.push(container);

      var btns = container.querySelectorAll('.button_switch');
      var wrapper = nearestWrapper(container);
      if (wrapper) wrapper.classList.add('ez-btnswitch');   // marks plain-img visibility (CSS)

      Array.prototype.forEach.call(btns, function (b) {
        if (b.__ezSwitchBound) return;
        b.__ezSwitchBound = true;
        b.style.cursor = 'pointer';
        b.addEventListener('click', function () {
          Array.prototype.forEach.call(btns, function (x) { x.classList.remove('active'); });
          b.classList.add('active');
          if (wrapper) setActive(wrapper, buttonIndex(b, btns));
        });
      });

      var active = container.querySelector('.button_switch.active') || btns[0];
      if (wrapper && active) setActive(wrapper, buttonIndex(active, btns)); // initial paint
    });
  }

  /* ---- Mobile normalization: scraped desktop css-* keep max-width + inline-block that
     shrink/mis-wrap on phones. Flip only elements that are actually inline-block (so flex/
     grid rows are untouched); max-width is handled in ez-switcher.css. Reversible on resize. */
  function normalizeMobile() {
    var mobile = window.matchMedia('(max-width: 767px)').matches;
    document.querySelectorAll('.ez-rawhtml [class*="css-"]').forEach(function (el) {
      if (mobile) {
        if (el.dataset.ezDisp === undefined && getComputedStyle(el).display === 'inline-block') {
          el.dataset.ezDisp = '1';
          el.style.display = 'block';
        }
      } else if (el.dataset.ezDisp !== undefined) {
        el.style.display = '';
        delete el.dataset.ezDisp;
      }
    });
  }

  function debounce(fn, wait) {
    var t;
    return function () { clearTimeout(t); t = setTimeout(fn, wait); };
  }

  function init(scope) {
    var root = scope || document;
    initCheckboxes(root);
    initButtons(root);

    // Safety: any wrapper still with no active image → show its first.
    root.querySelectorAll('.ez-rawhtml [class*="switch_wrapper"]').forEach(function (w) {
      var imgs = imagesOf(w);
      if (imgs.length && !w.querySelector('img.active')) imgs[0].classList.add('active');
    });

    normalizeMobile();
  }

  window.ezSwitcherInit = init;
  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', function () { init(); });
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  window.addEventListener('resize', debounce(normalizeMobile, 150));
})();
